export default __webpack_public_path__ + "static/media/machu_picchu-autoportrait.e1e54698.jpg";